import { createApi } from "@reduxjs/toolkit/query/react";
import { axiosBaseQuery } from "./helpers/base-query";
import { posApiInstance } from "./axios/api-instances";

const baseQuery = axiosBaseQuery(posApiInstance);

export const posApi = createApi({
  reducerPath: "posApi",
  baseQuery,
  endpoints: (builder) => ({
    zones: builder.query<
      {
        results: {
          id: string;
          zone_type: number;
          description: string;
          symmetric_key: string;
          zone_min_x: number;
          zone_min_y: number;
          zone_max_x: number;
          zone_max_y: number;
        }[];
        count: 0;
      },
      void
    >({
      query: () => ({
        url: `/sku_in_box/zones`,
      }),
    }),

    mobileCheckout: builder.mutation<void, MobileCheckoutVariables>({
      query: (body) => ({
        url: `/kiosk/full_autonomous/checkout`,
        method: "POST",
        data: body,
      }),
    }),
  }),
});

export const { useMobileCheckoutMutation, useZonesQuery } = posApi;

type MobileCheckoutVariables = {
  timestamp: string;
  token: string;
  user_id: string;
  card_id: string;
  user_type: string;
  email: string;
  zone_id: string;
};
